const initialState = {
  applePayAuthToken: '',
}

export default initialState
